export default __webpack_public_path__ + "static/media/iab-hero-img.5504d5d0.svg";